import {
    SEND_OTP_REQUEST,
    SEND_OTP_SUCCESS,
    SEND_OTP_FAILURE,
  } from "../../constants/constants"
  
  const initialState = {
    loading: false,
    error: null,
    data: null,
  };
  
  const sendOtpReducer = (state = initialState, action) => {
    switch (action.type) {
      case SEND_OTP_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case SEND_OTP_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      case SEND_OTP_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default sendOtpReducer;
  